// extracted by mini-css-extract-plugin
export default {"dropdownSelect":"OrderTypeDropdown_dropdownSelect__owrP5"};